import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';

export default function isApprovalResponse(viewState: ComposeViewState): boolean {
    return (
        viewState.operation === ComposeOperation.Approve ||
        viewState.operation === ComposeOperation.Reject
    );
}
